// Cada paso: { element?, popover, ui? }. `ui` = estado de la página que ese paso necesita.
export function conTransiciones(steps, setUi, delay = 320) {
  const last = steps.length - 1
  return steps.map((s, i) => {
    const popover = { ...s.popover }

    const mover = (dir) => (_el, _step, { driver }) => {
      const destino = steps[i + dir]
      const cambia = (destino?.ui ?? null) !== (s.ui ?? null)
      if (cambia) setUi(destino?.ui ?? null)
      const go = () => (dir > 0 ? driver.moveNext() : driver.movePrevious())
      cambia ? setTimeout(go, delay) : go()
    }

    if (i < last) popover.onNextClick = mover(1)
    if (i > 0) popover.onPrevClick = mover(-1)

    return { element: s.element, popover }
  })
}